import { assign, find, findIndex } from 'lodash'

import Vue from 'vue'

import HTTP from '@/common/HTTP'
import { actionTypes, mutationTypes } from './SurveyVersionsTypes';
import { actionTypes as globalActionTypes } from './GlobalTypes';

function initialState() {
  return {
    versions: [],
    previewSheets: [],
  }
}

const mutations = {

  [mutationTypes.SET_VERSIONS](state, versions) {
    state.versions = versions
  },

  [mutationTypes.REPLACE_VERSION](state, version) {
    const oldVersion = find(state.versions, { id: version.id })
    if (oldVersion) {
      assign(oldVersion, version)
    } else {
      state.versions.push(version)
    }
  },

  [mutationTypes.DELETE_VERSION](state, version) {
    Vue.delete(state.versions, findIndex(state.versions, { id: version.id }))
  },

  [mutationTypes.ADD_PREVIEW_SHEET](state, sheet) {
    state.previewSheets.push(sheet)
  },

  [mutationTypes.RESET_PREVIEWS](state) {
    state.previewSheets = []
  },

  [mutationTypes.RESET_VERSIONS](state) {
    state.versions = []
  },

  [mutationTypes.CLOSE_PREVIEW_SHEET](state, versionId) {
    Vue.delete(state.previewSheets, findIndex(state.previewSheets, { version: { id: versionId } }))
  }
}

const actions = {

  async [actionTypes.FETCH_VERSIONS]({ commit }, surveyId) {
    const { data } = await HTTP.get(`/surveys/${surveyId}/versions`)
    commit(mutationTypes.SET_VERSIONS, data)
    return data
  },

  async [actionTypes.ADD_PREVIEW_SHEET]({ commit }, versionId) {
    const version = (await HTTP.get(`/surveys/versions/${versionId}`)).data
    const questionSheet = (await HTTP.get(`/surveys/${version.survey.id}/versions/${versionId}/question-sheet`)).data
    commit(mutationTypes.ADD_PREVIEW_SHEET, {
      version,
      questionSheet
    })
  },

  async [actionTypes.CREATE_VERSION]({ commit, dispatch, rootState }, { surveyId, versionAdd }) {
    versionAdd.questionSheet = rootState.Drafts.draft;
    const { data } = await HTTP.post(`/surveys/${surveyId}/versions`, versionAdd)
    commit(mutationTypes.REPLACE_VERSION, data)
    dispatch(actionTypes.FETCH_VERSIONS, surveyId)
    return data
  },

  async [actionTypes.UPDATE_VERSION]({ commit }, { surveyId, versionEdit }) {
    const { data } = await HTTP.patch(`/surveys/${surveyId}/versions/${versionEdit.id}`, versionEdit)
    commit(mutationTypes.REPLACE_VERSION, data)
    return data
  },

  async [actionTypes.DELETE_VERSION]({ commit, dispatch }, { surveyId, version }) {
    try {
      await HTTP.delete(`/surveys/${surveyId}/versions/${version.id}`)
      commit(mutationTypes.DELETE_VERSION, version)
    } catch (e) {
      dispatch(globalActionTypes.SHOW_SNACKBAR, {
        message: 'Diese Version wird bereits in einem Audit verwendet',
        color: 'error'
      }, { root: true })
    }
  }

}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/SurveyVersions.js